module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.1.6.0@rc-switch/es/index.js
// module id = 422
// module chunks = 1